import { r as registerInstance, h, H as Host } from './index-5faac9d7.js';

const sustainabilityPortalCss = ".tooltip-wrapper-modal-content{color:#626469;font-size:14px;position:relative;display:flex;justify-content:center;flex-direction:column;padding:0 30px 32px}";

const PortalComponent = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.reference = undefined;
    this.isOpen = false;
  }
  didPopupClose() {
    this.closeDialog();
  }
  closeDialog() {
    this.isOpen = false;
  }
  render() {
    return (h(Host, null, h("se-dialog", { open: this.isOpen, size: "small", noBackdrop: true, pageScroll: false, color: "alternative" }, h("se-dialog-header", { "close-icon": "true", color: "alternative", padding: "small" }), h("se-dialog-content", { color: "alternative", padding: "none" }, h("div", { class: "tooltip-wrapper-modal-content" }, h("slot", { name: "tooltip-content" }))))));
  }
};
PortalComponent.style = sustainabilityPortalCss;

export { PortalComponent as pes_sustainability_portal };
